module.exports = __webpack_public_path__ + "static/media/article2sqr.65e799ac.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/articles/article2sqr.jpeg
// module id = 95
// module chunks = 0